import * as React from 'react';
import mdata from '../hybriddata/mainform.json';
import ftImg from '../hybridImages/FinancingTypeTable.png';
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import FinancingTypeExplanation from './FinancingTypeExplanation';

const CloseModalButton = styled(MdClose)`
color: white;
cursor: pointer;
position: absolute;
top: 10px;
right: 10px;
width: 32px;
height: 32px;
`;

const FinancingTypeTooltip = (props) =>  {

    return props.popupValue && (
    <div className="popup">
        <div className="popup-inner">
        <CloseModalButton
            aria-label="Close modal"
                onClick={() =>{
                    props.setPopupValue(false);
                } }
            />
        <div className='fbaPSize'>
            <div className="bgBlackYellowBorder">
                <div className="row">
                    <div className="col-10">
                        <div className="dcPgmh">{mdata.tooltip.title}</div>
                    </div>
                </div>
            </div><br/>
        </div>
        <div className='fbaPSize'>
            <p className="ft-p-txt">{mdata.tooltip.desc}</p>
        </div>
        <div className='titleImgHeader'>
            {/* <img src={ftImg} alt="ftImg1"></img> */}
            <FinancingTypeExplanation />
        </div>
         
        </div>
    </div>
    )
}

export default FinancingTypeTooltip;